import { Link } from 'react-router-dom';
import { ClipboardDocumentListIcon, ListBulletIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import { useAuth, ROLE_ADMIN, ROLE_EVALUATION_ADMIN } from '@/contexts/AuthContext';

const modules = [
    {
        name: 'Avaliações',
        description: 'Gerencie ciclos e campanhas de avaliação de desempenho.',
        icon: ClipboardDocumentListIcon,
        to: '/people/evaluations',
        color: 'text-indigo-600',
        bg: 'bg-indigo-50',
        requiredRoles: [ROLE_ADMIN, ROLE_EVALUATION_ADMIN],
    },
    {
        name: 'Questionários',
        description: 'Crie e gerencie modelos de questionários e critérios.',
        icon: ListBulletIcon,
        to: '/people/evaluations/questionnaires',
        color: 'text-indigo-600',
        bg: 'bg-indigo-50',
        requiredRoles: [ROLE_ADMIN, ROLE_EVALUATION_ADMIN],
    },
    {
        name: 'Escalas',
        description: 'Defina as escalas de pontuação utilizadas nas avaliações.',
        icon: AdjustmentsHorizontalIcon,
        to: '/people/evaluations/scales',
        color: 'text-indigo-600',
        bg: 'bg-indigo-50',
        requiredRoles: [ROLE_ADMIN, ROLE_EVALUATION_ADMIN],
    },
];

export function PeopleDashboardPage() {
    const { userHasRole } = useAuth();
    const visibleModules = modules.filter((module) => module.requiredRoles.some((role) => userHasRole(role)));

    return (
        <div className="space-y-6">
            <header className="space-y-2">
                <p className="text-sm font-semibold text-primary-700">Gestão de Pessoas</p>
                <h1 className="text-3xl font-bold text-gray-900">Visão geral</h1>
                <p className="max-w-2xl text-sm text-gray-600">
                    Central de gestão de iniciativas de pessoas e cultura.
                </p>
            </header>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {visibleModules.map((module) => (
                    <Link
                        key={module.name}
                        to={module.to}
                        className="group flex h-full w-full flex-col justify-between gap-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        <div className="flex items-start justify-between gap-4">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-900">{module.name}</h2>
                                <p className="mt-2 text-sm text-gray-500">{module.description}</p>
                            </div>
                            <span className={`rounded-full p-3 ${module.bg} ${module.color}`}>
                                <module.icon className="h-6 w-6" aria-hidden />
                            </span>
                        </div>

                        <div className="flex items-center text-sm font-medium text-indigo-600 group-hover:text-indigo-700">
                            Acessar módulo
                            <span className="ml-1 transition-transform group-hover:translate-x-1">→</span>
                        </div>
                    </Link>
                ))}
            </div>

            {visibleModules.length === 0 ? (
                <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-6 text-sm text-gray-600">
                    Nenhum módulo de People está disponível para o seu perfil no momento.
                </div>
            ) : null}
        </div>
    );
}
